module.exports = __webpack_public_path__ + "img/earth.01f5034f.png";